<template>
    <el-dialog class="el-dialogs" :title="title" width="500px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent style="height: 300px"
                 label-width="110px">
            <el-form-item label="学术资源范围" prop="academicName">
                <el-input v-model.trim="searchForm.academicName" maxlength="20"
                          placeholder="请输入学术资源范围(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="链接地址" prop="academicAddress">
                <el-input
                    type="textarea"
                    :rows="5" maxlength="500" resize="none"
                    placeholder="请输入链接地址(限500字)"
                    v-model.trim="searchForm.academicAddress">
                </el-input>
            </el-form-item>
            <el-form-item label="状态" prop="academicState">
                <el-switch
                        v-model="searchForm.academicState"
                        active-value="1"
                        inactive-value="0">
                </el-switch>
            </el-form-item>
            <div v-show="title == '编辑学术资源范围'">
                <el-form-item label="添加人" prop="type">
                    <div>{{ searchForm.createByName }}</div>
                </el-form-item>
                <el-form-item label="添加时间" prop="type">
                    <div>{{ searchForm.createDate }}</div>
                </el-form-item>
                <el-form-item label="最后修改时间" prop="type">
                    <div>{{ searchForm.updateDate }}</div>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "addAcademic",
    data() {
        return {
            title: '新增学术资源范围',
            visible: false,
            searchForm: {
                academicName: '',
                academicAddress: '',
                academicState: '0',
            },
            rules: {
                academicName: [
                    {required: true, message: '请输入学术资源范围', trigger: 'blur'}
                ],
                academicAddress: [
                    {required: true, message: '请输入链接地址', trigger: 'blur'}
                ],
            },
        }
    },

    methods: {
        init(num, row) {
            this.searchForm = {
                academicName: '',
                academicAddress: '',
                academicState: '0',
            }
            this.visible = true
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            if (num == 0) {
                this.title = '新增学术资源范围'
            }
            if (num == 2) {
                this.title = '编辑学术资源范围'
                this.$axios(this.api.academic.academicresourcesGetById + row.id, {}).then(data => {
                    if (data && data.status) {
                        this.searchForm = data.data
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.academicresourcesUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.academicresourcesSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>